export const SuspendedIcon = (props: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      fill="none"
      viewBox="0 0 15 15"
      {...props}
    >
      <path
        stroke="#787878"
        strokeMiterlimit="10"
        d="M7.735 14.47a6.735 6.735 0 100-13.47 6.735 6.735 0 000 13.47z"
      ></path>
      <path
        stroke="#787878"
        strokeLinecap="round"
        strokeMiterlimit="10"
        d="M10 5.688l-4.625 4.625"
      ></path>
    </svg>
  );
};
